<template>
    <nav class="flex mb-2" aria-label="Breadcrumb">
        <div class="flex items-center" v-if="items.length > 3" :class="{ 'md:hidden flex': items.length > 3 }">
            <Link
                :href="items.length > 1 ? items[items.length - 3]?.url || '#' : '#'"
                class="link hover:text-dgreen-dark"
            >
                <fa :icon="['fal', 'chevron-left']" class="size-4 shrink-0" aria-hidden="true"></fa>
            </Link>
            <Link
                :href="items.length > 1 ? items[items.length - 3]?.url || '#' : '#'"
                class="ml-2 text-sm font-medium link truncate hover:text-dgreen"
            >
                {{ items.length > 1 ? items[items.length - 3].title : '' }}
            </Link>
        </div>

        <!-- Desktop view - full breadcrumb -->
        <ol role="list" class="flex items-center space-x-2" :class="{ 'hidden md:flex': items.length > 3 }">
            <li>
                <div>
                    <Link href="/" class="text-gray-500 hover:text-dgreen-dark" title="Ga naar homepagina">
                        <fa :icon="['fas', 'house']" class="size-3 shrink-0" aria-hidden="true"></fa>
                        <span class="sr-only">Home</span>
                    </Link>
                </div>
            </li>
            <li v-for="(item, index) in items" :key="index">
                <div class="flex items-center">
                    <fa :icon="['fal', 'chevron-right']" class="size-2 shrink-0 text-dgreen" aria-hidden="true"></fa>
                    <template v-if="index === items.length - 1">
                        <span
                            class="ml-2 text-sm md:text-xs font-medium text-gray-500"
                            :title="item.title"
                        >
                            {{ item.title }}
                        </span>
                    </template>
                    <Link
                        v-else
                        :href="item.url"
                        class="ml-2 text-sm md:text-xs font-medium link hover:text-dgreen"
                        :title="item.title"
                    >
                        {{ item.title }}
                    </Link>
                </div>
            </li>
        </ol>
    </nav>
</template>

<script setup>
import { usePage } from '@inertiajs/vue3';
import { computed } from 'vue';

const page = usePage();
const items = computed(() => {
    const breadcrumbs = page.props.breadcrumbs;
    if (!Array.isArray(breadcrumbs)) {
        return [];
    }
    return breadcrumbs.filter((item) => item.title !== 'Home');
});
</script>
